import { LIGHT_MODE, DARK_MODE } from '../../modes';
import * as colorNames from '../../constants';
import { colorsSetToNumbers } from '../../utils';

/*
 * WARN: those colors are static, you can't add key here without defining it for other customers
 */
export const staticColors = {
  [LIGHT_MODE]: {
    [colorNames.PRIMARY]: '#000000',
    [colorNames.SECONDARY]: '#F7F8F9',
    [colorNames.TERTIARY]: '#ffffff',
    [colorNames.QUATERNARY]: '#AFB0B6',
    [colorNames.QUINARY]: '#5B14B8',
    [colorNames.UTILITY1]: '#da3b2b',
    [colorNames.UTILITY2]: '#4ed569',
    [colorNames.UTILITY3]: '#ffb002',
    [colorNames.UTILITY4]: '#4A90E2',
    [colorNames.ECO]: '#48b755',
    [colorNames.LIVE]: '#E71700',
    [colorNames.HIGHLIGHT]: '#e6e6e6',
    [colorNames.CLOUD_DARK]: '#000000',
    [colorNames.CLOUD_NORMAL]: '#6F7175',
    [colorNames.CLOUD_WHITE]: '#ffffff',
  },
  [DARK_MODE]: {
    [colorNames.PRIMARY]: '#ffffff',
    [colorNames.SECONDARY]: '#F7F8F9',
    [colorNames.TERTIARY]: '#000000',
    [colorNames.QUATERNARY]: '#AFB0B6',
    [colorNames.QUINARY]: '#5B14B8',
    [colorNames.UTILITY1]: '#da3b2b',
    [colorNames.UTILITY2]: '#4ed569',
    [colorNames.UTILITY3]: '#ffb002',
    [colorNames.UTILITY4]: '#4A90E2',
    [colorNames.ECO]: '#48b755',
    [colorNames.LIVE]: '#E71700',
    [colorNames.HIGHLIGHT]: '#252525',
    [colorNames.CLOUD_DARK]: '#000000',
    [colorNames.CLOUD_NORMAL]: '#6F7175',
    [colorNames.CLOUD_WHITE]: '#ffffff',
  },
};

export const colors = colorsSetToNumbers(staticColors);
